import { render, staticRenderFns } from "./AddPhysicalDoc.vue?vue&type=template&id=d6bcb20e&scoped=true&"
import script from "./AddPhysicalDoc.vue?vue&type=script&lang=js&"
export * from "./AddPhysicalDoc.vue?vue&type=script&lang=js&"
import style0 from "./AddPhysicalDoc.vue?vue&type=style&index=0&id=d6bcb20e&lang=scss&scoped=true&"
import style1 from "./AddPhysicalDoc.vue?vue&type=style&index=1&id=d6bcb20e&scoped=true&lang=css&"
import style2 from "../../styles/physical-doc-dialog.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bcb20e",
  null
  
)

export default component.exports